import { rem } from '@mantine/core'

/** Общая геометрия сайдбара — одна сетка для шеврона, отступов и подпунктов */
export const SIDEBAR_NAV_LAYOUT = {
  rowMinHeight: 34,
  padX: 8,
  chevronCol: 24,
  chevronGap: 4,
  /** Отступ подпунктов: колонка шеврона + gap (совпадает с началом NavLink) */
  subIndent: 24 + 4,
} as const

/** Стили NavLink: одна линия, ровные отступы, свёрнутый режим только с иконкой */
export function sidebarNavLinkStyles(collapsed: boolean) {
  const { rowMinHeight, padX } = SIDEBAR_NAV_LAYOUT
  return {
    root: {
      borderRadius: 'var(--mantine-radius-lg)',
      transition:
        'background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1), color 0.15s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.15s ease',
      minHeight: rowMinHeight,
      alignItems: 'center',
      paddingTop: rem(4),
      paddingBottom: rem(4),
      border: '1px solid transparent',
      marginBottom: rem(2),
      '&:hover': {
        background: 'light-dark(rgba(248,250,252,0.96), rgba(37,38,43,0.82))',
        borderColor: 'light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4))',
      },
      '&[data-active]': {
        background:
          'linear-gradient(135deg, var(--mantine-color-brand-light), light-dark(#ffffff, var(--mantine-color-dark-6)))',
        borderColor: 'var(--mantine-color-brand-outline)',
        boxShadow: '0 8px 20px light-dark(rgba(37,99,235,0.12), rgba(0,0,0,0.24))',
      },
      ...(collapsed
        ? {
            justifyContent: 'center',
            paddingLeft: 6,
            paddingRight: 6,
          }
        : {
            paddingLeft: padX,
            paddingRight: padX,
          }),
    },
    body: collapsed
      ? ({ display: 'none' } as const)
      : {
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
        },
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap' as const,
      lineHeight: 1.25,
      fontSize: rem(13.5),
      fontWeight: 500,
    },
    section: {
      flexShrink: 0,
    },
  }
}
